import type { CustomColumnItem, ID, LotChanges } from 'types';

/** One lot's overlay entry without any pending cell for a removed column, on rows of any page. */
export const dropPendingColumnCells = (lotChanges: LotChanges, headerId: ID): LotChanges => {
  if (!lotChanges.line_items) return lotChanges;
  const isRemoved = (cell?: CustomColumnItem): boolean => String(cell?.custom_column_header_id) === String(headerId);

  const lineItems = Object.fromEntries(Object.entries(lotChanges.line_items).map(([rowId, row]) => {
    const cells = row?.custom_column_items;
    if (!cells || !Object.values(cells).some(isRemoved)) return [rowId, row];

    return [rowId, { ...row, custom_column_items: Object.fromEntries(Object.entries(cells).filter(([, cell]) => !isRemoved(cell))) }];
  }));

  return { ...lotChanges, line_items: lineItems };
};
